import { render } from "./medium.vue?vue&type=template&id=6b27665e&lang=pug"
import script from "./medium.vue?vue&type=script&lang=js"
export * from "./medium.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__